// extracted by mini-css-extract-plugin
module.exports = {"switch":"Switch_switch__7RsZL","hiddenCheckbox":"Switch_hiddenCheckbox__kxW8K","track":"Switch_track__8FxQR","thumb":"Switch_thumb__4h9R2"};